import styles from './NotFound.module.scss';

import type { FC } from 'react';
import { Link } from 'react-router';

export const NotFound: FC = () => {
  return (
    <div className="content-wrapper">
      <div className={styles.container}>
        <h1>The page you were looking for doesn't&nbsp;exist.</h1>

        <p>
          You may have mistyped the address or the page may have&nbsp;moved.
        </p>

        <hr className={styles.rule} />

        <h1>
          Die angeforderte Seite konnte leider nicht gefunden&nbsp;werden.
        </h1>

        <p>
          M&ouml;glicherweise wurde die Adresse falsch eingegeben, oder die
          Seite&nbsp;verschoben.
        </p>

        <Link className={styles.link} to="/">
          Home
        </Link>
      </div>
    </div>
  );
};
